import {BACKEND} from '../../../../consts/backend';
import {apiKey} from './keys.helper';

export const GetExpoEntities = async () => {
  const requestOptions = {
    method: 'GET',
    redirect: 'follow',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: apiKey,
    },
  };

  try {
    const resp = await fetch(
      `${BACKEND}/expo-entities`,
      requestOptions
    );

    const data = await resp.json();
    return data;
  } catch (err) {
    console.error('Error fetching expo entities:', err);
    return { error: err.message, data: [] };
  }
};

export const UpdateEntityExpo = async (po, entitie_identifier, new_entite_id, usuario, pivot_entities_id, shipment_number) => {
  const formData = new FormData();
  var user = [usuario.email, usuario.name];
  formData.append('po', po);
  formData.append('entitie_identifier', entitie_identifier);
  formData.append('new_entite_id', new_entite_id);
  formData.append('user', user);
  formData.append('pivot_entities_id', pivot_entities_id);
  formData.append('shipment_number', shipment_number ?? '');
  
  const requestOptions = {
    method: 'POST',
    redirect: 'follow',
    headers: {
      Authorization: apiKey,
    },
    body: formData,
  };

  try {
    const resp = await fetch(
      `${BACKEND}/updateEntitieExpo`,
      requestOptions
    );

    const data = await resp.json();
    return data;
  } catch (err) {
    console.error('Error updating entity:', err);
    return { error: err.message, message: null };
  }
};